module.exports = __webpack_public_path__ + "static/img/release-backoff.26ca337.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/release-backoff.png
// module id = DwzR
// module chunks = 36